export const downloadConstants = {
  DOWNLOAD_HAS_ERRORED: 'DOWNLOAD_HAS_ERRORED',
  DOWNLOAD_IS_LOADING: 'DOWNLOAD_IS_LOADING',
  DOWNLOAD_FETCH_DATA_SUCCESS: 'DOWNLOAD_FETCH_DATA_SUCCESS',
  DOWNLOAD_DEL_ONE_SUCCESS: 'DOWNLOAD_DEL_ONE_SUCCESS',
  DOWNLOAD_GET_ONE_SUCCESS: 'DOWNLOAD_GET_ONE_SUCCESS',
  DOWNLOAD_GET_ALL_SUCCESS: 'DOWNLOAD_GET_ALL_SUCCESS',
};
